import { create } from 'zustand';


const medicineCart = (set, get) => ({
    cart: [],
    cartTracker: new Map(),
    orderInfo: { orderType: 'Medicines' },
    // Functions
    addToCart: (cartItem) => {
        const { id } = cartItem;
        const cart = [...get().cart, cartItem];

        const cartTracker = new Map(get().cartTracker).set(id, cartItem);
        set(state => ({...state, cart, cartTracker}));
    },
    incItemQty: (itemID) => {
        const prevCartTracker = get().cartTracker;
        const cartItem = prevCartTracker.get(itemID);
        cartItem.qty++;
        cartItem.price = cartItem.basePrice * cartItem.qty;
        const cartTracker = new Map(prevCartTracker).set(itemID, cartItem);
        const cart = [...cartTracker.values()];
        set(state => ({...state, cart, cartTracker}));
    },
    decItemQty: (itemID) => {
        const prevCartTracker = get().cartTracker;
        const cartItem = prevCartTracker.get(itemID);
        cartItem.qty--;
        const cartTracker = new Map(prevCartTracker);
        if (cartItem.qty === 0) {
            cartTracker.delete(itemID);
        } else {
            cartItem.price = cartItem.basePrice * cartItem.qty;
            cartTracker.set(itemID, cartItem);
        }
        const cart = [...cartTracker.values()];
        set(state => ({...state, cart, cartTracker}));
    },
    removeFromCart: (itemID) => {
        const cartTracker = new Map(get().cartTracker);
        cartTracker.delete(itemID);
        const cart = [...cartTracker.values()];

        set(state => ({...state, cart, cartTracker}));
    },
    updateCartOrderInfo: (orderInfoData) => set(state => ({...state, orderInfo: orderInfoData})),
});

const useMedicineStore = create(medicineCart);
export default useMedicineStore;